import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(ScrollTrigger, TextPlugin);

function isMobile() {
	const mdWidth = window.innerWidth || document.documentElement.clientWidth;
	return (mdWidth > 720) ? false : true;
}

/* animazione di trottola seguendo lo scroll */
export const verticalScrollSlideDownAnimation = () => {
	gsap.utils.toArray(".vl-icon").forEach((el, i) => {
		gsap.to(el, {
			scrollTrigger: {
				trigger: el.parentElement,
				scrub: 2,
				start: "bottom bottom",
				end: "top top",
				markers: false
			},
			y: el.parentElement.offsetHeight - el.offsetHeight,
			rotationY: 180 * 2,
			ease: "none",
			//transformOrigin: "left center",
		});
	});
}


/* animazione immagini */
export const percorsiImgAnim = () => {
	gsap.utils.toArray(".percorso-img-container img").forEach((el, i) => {
		gsap.to(el, {
			scrollTrigger: {
				trigger: el,
				start: "top-=40px center",
				toggleActions: "play none none none",
				markers: false,
			},
			duration: 2.5,
			width: "100%",
			autoAlpha: 1,
			ease: "power4.out",
		});
	});
};


/* arrow-links immagini della homepage */
export const arrowLinkHpAnim = () => {
	gsap.utils.toArray(".arrow-link-sm-container").forEach((el) => {
		gsap.to(el, {
			scrollTrigger: {
				trigger: el,
				start: "top-=0 center",
				end: "bottom+=20px center-=80px",
				toggleActions: "play none none none",
				markers: false,
				once: true,
				onEnter: () => {
					el.classList.add("hovered");
				},
				onLeave: () => {
					el.classList.remove("hovered");
				}
			},
		});
	});
};


/* fadein dei loghi tecnologie e clienti */
export const animateLogoImages = () => {
	const logoImages = gsap.utils.toArray(".logo-cliente-link .logo-cliente");
	gsap.set(logoImages, { opacity: 0 });

	logoImages.forEach((el, i) => {
		gsap.to(el, {
			duration: 1,
			opacity: 1,
			ease: "none",
			delay: i * 0.15,
			scrollTrigger: {
				trigger: el,
				start: "top bottom-=100px",
				end: "bottom center",
				markers: false,
				toggleActions: "play none none none",
			},
		});
	});
};


/* masonry elements */
export const masonryElAnim = () => {
	gsap.utils.toArray(".ms-grid > div").forEach((el) => {
		gsap.set(el, { autoAlpha: 0, y: 30 });

		gsap.to(el, {
			duration: 0.5,
			autoAlpha: 1,
			y: 0, //effetto "fade in up"
			ease: "power2.out",
			markers: false,
			scrollTrigger: {
				trigger: el,
				start: "top bottom-=100",
				end: "bottom top+=100",
				toggleActions: "play none none none"
			}
		});
	});
};

/* background image parallax */
export const bgParallaxAnim = () => {
	gsap.utils.toArray(".vh-80").forEach((el) => {
		gsap.to(el, {
			yPercent: isMobile() ? -15 : -30,
			ease: "none",
			scrollTrigger: {
				trigger: el,
				start: "top top",
				end: "bottom top-=200px",
				markers: false,
				scrub: true
			},
		});
	});
};


/* cite parallax */
export const citeParallaxAnim = () => {
	gsap.utils.toArray(".no-photo-cite-container").forEach((el) => {
		gsap.to(el, {
			yPercent: -40,
			ease: "none",
			scrollTrigger: {
				trigger: el,
				start: "top+=40px center+=100px",
				end: "bottom-=40px top+=100px",
				markers: false,
				scrub: true
			},
		});
	});
};


/* scritte animate a due livelli */
export const percorsiDescriptionAnim = () => {
	gsap.utils.toArray(".anim-text").forEach((el, i) => {
		var tl = gsap.timeline({
			scrollTrigger: {
				trigger: el.parentElement,
				start: "top-=100px bottom",
				toggleActions: "play none none none",
				markers: false,
				delay: 3
			},
		});

		var firstBg = el.querySelectorAll('.text__first-bg'),
			secBg = el.querySelectorAll('.text__second-bg'),
			word = el.querySelectorAll('.text__word');

		tl
			.to(firstBg, 0.5, { scaleX: 1 })
			.to(secBg, 0.5, { scaleX: 1 })
			.to(word, 0.3, { opacity: 1 }, "-=0.1")
			.to(firstBg, 0.5, { scaleX: 0 })
			.to(secBg, 0.5, { scaleX: 0 });
	});
};


//// animazione video di accompagnamento
//export const animateVideoScroll = () => {
//	const video = $("#globeVideo");
//	const percorsoTitles = $(".percorso-title");

//	percorsoTitles.each(function (i) {
//		const percorsoTitle = $(this);
//		gsap.to(video, {
//			yPercent: -50,
//			scrollTrigger: {
//				trigger: percorsoTitle,
//				start: "top-=100px bottom-=200px",
//				end: "bottom top",
//				scrub: true,
//				markers: true,
//				onEnter: () => {
//					const viewHeight = $(window).height();
//					const percorsoTitlePosition = percorsoTitle.position();
//					const videoPosition = {
//						x: percorsoTitlePosition.left + percorsoTitle.parent().parent().width() + 50,
//						y: (percorsoTitlePosition.top + (viewHeight / 2)),
//					};

//					if (percorsoTitlePosition.left < 100) {
//						videoPosition.x = percorsoTitlePosition.left - video.width()/4;
//					}

//					gsap.to(video, {
//						duration: 2,
//						autoAlpha: 1,
//						ease: "power2.out",
//						x: videoPosition.x,
//						y: videoPosition.y,
//					});
//				},
//				onLeave: () => {
//					if (i == percorsoTitles.length - 1) {
//						gsap.to(video, {
//							duration: 0.5,
//							autoAlpha: 0,
//						});
//					}
//				},
//				onEnterBack: () => {
//					gsap.to(video, {
//						duration: 0.5,
//						autoAlpha: 0,
//					});
//				}
//			},
//		});

//	});

//};


/** BY DAVIDE */
//export const heroTitleAnimation = () => {
//	const el = document.getElementById("animated-hero-title")
//	const content = el.dataset.content

//	gsap.to("#animated-hero-title", {
//		duration: 4,
//		text: {
//			value: content,
//			delimiter: ""
//		},
//		ease: "none"
//	});
//}

// heroTitleAnimation()
/** BY DAVIDE */